import { Component, Input, OnInit } from '@angular/core';
import { TourService, TourStep } from '../../services/tour.service';
import { TourConfigService } from '../../services/tour-config.service';
import { DynamicTourService } from '../../services/dynamic-tour.service';
import { UserSettingsService } from '../../services/user-settings.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../stores/states/app.state';
import * as UserActions from '../../stores/actions/user.actions';

@Component({
  selector: 'app-header-tour-button',
  templateUrl: './header-tour-button.component.html',
  styleUrls: ['./header-tour-button.component.scss']
})
export class HeaderTourButtonComponent implements OnInit {
  @Input() tourSteps: TourStep[] = [];
  @Input() currentUser: any = null;
  @Input() showResetOption: boolean = true;

  tourTitle: string = 'Quick Guide';
  tourIcon: string = 'help-circle';

  constructor(
    private tourService: TourService,
    private tourConfigService: TourConfigService,
    private dynamicTourService: DynamicTourService,
    private userSettingsService: UserSettingsService,
    private store: Store<AppState>
  ) { }

  ngOnInit(): void {

    this.tourTitle = this.dynamicTourService.getTourTitleForCurrentRoute();
    this.tourIcon = this.dynamicTourService.getTourIconForCurrentRoute();
  }

  startTour(): void {
    if (this.tourSteps.length > 0) {
      this.tourService.initTour(this.tourSteps);
      this.tourService.start();
    } else {

      const tourSteps = this.dynamicTourService.getTourStepsForCurrentRoute();
      this.tourService.initTour(tourSteps);
      this.tourService.start();
    }
  }


  hasSeenTour(): boolean {
    return this.currentUser?.settings?.showTourOnFirstVisit === false;
  }


  async resetTourSetting(): Promise<void> {
    try {
      const userSettings = this.currentUser?.settings || {};
      await this.userSettingsService.save({
        ...userSettings,
        showTourOnFirstVisit: true,
      });


      this.store.dispatch(UserActions.updateUserSettings({
        settings: { ...userSettings, showTourOnFirstVisit: true }
      }));

      this.currentUser = {
        ...this.currentUser,
        settings: { ...userSettings, showTourOnFirstVisit: true }
      };
    } catch (error) {
      console.error('Error resetting tour setting:', error);
    }
  }


  private checkTourElementsExist(): boolean {
    const requiredElements = [
      '#dashboard-title',
      '#stats-boxes',
      '#doc-types-stats',
      '#relevant-keys-stats',
      '#news-feed',
      '#today-schedule',
      '#map-component',
      '#congress-calendar'
    ];

    return requiredElements.every(selector => {
      const element = document.querySelector(selector) as HTMLElement;
      return element && element.offsetWidth > 0 && element.offsetHeight > 0;
    });
  }
}
